import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

// init без установки lng (он будет задан вручную ниже)
i18n
.use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    backend: {
      loadPath: "/locales/{{lng}}/translation.json"
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: true
    }
  })
  .then(() => {
    console.log("✅ i18n.init complete. Current language:", i18n.language);
  });

// лог на каждое изменение языка
i18n.on("languageChanged", (lng) => {
  console.log("🌐 i18n: languageChanged →", lng);
});

// обёртка вокруг changeLanguage — покажет, кто его вызывает
const originalChangeLanguage = i18n.changeLanguage.bind(i18n);
i18n.changeLanguage = (...args) => {
  console.log("⚠️ i18n.changeLanguage called with:", args);
  return originalChangeLanguage(...args);
};

// жёсткая установка языка по домену
if (typeof window !== "undefined") {
  const host = window.location.hostname;
  if (host.includes("pokerly.online") || host.includes("pokerly-test.web.app")) {
    i18n.changeLanguage("en");
  } else if (host.includes("pokerly.ru")) {
    i18n.changeLanguage("ru");
  }
}

export default i18n;
